exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.summaryInfo__info___i71e9 {\n  color: #828282;\n  font-size: 12px;\n  line-height: 27px;\n  margin-bottom: 14px; }\n  .summaryInfo__info___i71e9 .summaryInfo__title___efv0e {\n    font-size: 23px;\n    line-height: 25px;\n    font-weight: 800;\n    margin-bottom: 10px;\n    color: #292929;\n    display: block;\n    word-break: break-word; }\n  .summaryInfo__info___i71e9 .summaryInfo__code___3g-cv, .summaryInfo__info___i71e9 .summaryInfo__viewedCount___cvc0q, .summaryInfo__info___i71e9 .summaryInfo__renewalTime___mssZo {\n    display: inline-block; }\n    .summaryInfo__info___i71e9 .summaryInfo__code___3g-cv::before, .summaryInfo__info___i71e9 .summaryInfo__viewedCount___cvc0q::before, .summaryInfo__info___i71e9 .summaryInfo__renewalTime___mssZo::before {\n      content: \"\\B7\";\n      margin-left: 6px;\n      margin-right: 6px;\n      font-weight: 800; }\n", ""]);

// exports
exports.locals = {
	"info": "summaryInfo__info___i71e9",
	"title": "summaryInfo__title___efv0e",
	"code": "summaryInfo__code___3g-cv",
	"viewedCount": "summaryInfo__viewedCount___cvc0q",
	"renewalTime": "summaryInfo__renewalTime___mssZo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/SummaryInfo/summaryInfo.scss
// module id = 4315
// module chunks = 6